import { UserAvatarFilled } from "@carbon/icons-react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import React from "react";

import { useUserContext } from "../../contexts/UserContext";
import { UserActionTypes } from "../../contexts/reducers/userReducer";

function NavbarUserDropdown() {
  const { dispatchUser } = useUserContext();
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = () => {
    dispatchUser({ type: UserActionTypes.Logout });
  };

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
          className="user-icon"
        >
          <UserAvatarFilled />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
